import { useCan } from '../../contexts/PermissionsContext'
import { useIsPlatformAdmin } from '../../hooks/useAuth'

/** useCanOpenRunDetails: data.write, or a platform admin (spec 2026-10-21-19 §3). */
export function useCanOpenRunDetails(): boolean {
    const canWrite = useCan('data.write')
    const isPlatformAdmin = useIsPlatformAdmin()
    return canWrite || isPlatformAdmin
}
